import { ApiService } from "../..";

export const loginWithSms = (
  sms: { bizId: string; code: string; phoneNumber: string },
  role: "admin" | "leader" | "member"
) => {
  return ApiService.baseAction(
    "auth/login/sms",
    {
      data: {
        sms,
        role,
      },
    },
    "post"
  );
};
